import { doc, onSnapshot } from 'firebase/firestore'
import { ref } from 'vue'
import firebase from '../../firebase'
const tags = ref(new Set())

const getSessionTags = (sessionId) => {

  const unsubscribe = onSnapshot(
    doc(firebase.db, 'sessions', sessionId),
    (sessionDoc) => {
      if (sessionDoc.exists()) {
        const sessionTags = sessionDoc.data().tags || []
        tags.value = new Set(sessionTags)
      } else {
        tags.value.clear()
      }
    }
  )

  return { tags, unsubscribe }
}

export default getSessionTags
